const getCategoryTitle = category => {
  let categoryTitle;
  switch (category) {
    case 'Applied':
      categoryTitle = 'Manufacturer Offers';
      break;
    case 'Standard':
      categoryTitle = 'Available Offers';
      break;
    case 'Conditional':
      categoryTitle = 'Conditional Offers';
      break;
    default:
      categoryTitle = category;
  }
  return categoryTitle;
};
const getDisplayOrder = category => {
  let order;
  switch (category) {
    case 'Manufacturer Offers':
      order = 0;
      break;
    case 'Available Offers':
      order = 1;
      break;
    case 'Conditional Offers':
      order = 2;
      break;
    default:
      order = 3;
  }
  return order;
};
const sortIncentives = (a, b) => getDisplayOrder(a.category) - getDisplayOrder(b.category);
const transformIncentives = function () {
  let incentives = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let appliedIncentiveIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return incentives.map(incentive => {
    const {
      incentiveId
    } = incentive;
    let category = incentive.programType;
    let isAppliedOffer = false;
    if (appliedIncentiveIds.includes(incentiveId)) {
      category = 'Applied';
      isAppliedOffer = true;
    }
    return {
      id: incentive.incentiveId,
      name: incentive.programName,
      expirationDate: incentive.endDate,
      category: getCategoryTitle(category),
      details: incentive.description,
      isAppliedOffer
    };
  }).sort(sortIncentives);
};
export { transformIncentives as default };
